import { InjectionToken } from '@angular/core';

export const SNACK_BAR_DATA = new InjectionToken('SNACK_BAR_DATA');
export const SNACK_BAR_REF = new InjectionToken('SNACK_BAR_REF');

export interface ISnackBarRef {
  dismiss: () => any;
}
